import { createReduxEnhancer } from '@sentry/react';

export const sentryReduxEnhancer = createReduxEnhancer({});
